import '../assets/scss/reset.scss';
import './setFontSize';
import Indicator from '../components/Indicator';
import Toast from '../components/Toast';
import * as api from '../utils/api';
import reportError from './reportError';
import * as appBridge from './appBridge';
import Vue from 'vue';
const qs = require('querystringify');
import { lang, getLang } from '../lang/index';
import _setTitle from './setTitle';
export const setTitle = _setTitle;
import loadTalkData from './loadTalkData';
import report from './report';
loadTalkData();

window.report = report;
window.reportError = reportError;

Vue.prototype.$lang = lang;
Vue.prototype.$t = getLang;

function showLog() {
  // 添加调试
  var script = document.createElement('script');
  var head = document.head || document.getElementsByTagName('head')[0];
  script.src =
    '//pub.idqqimg.com/qqun/qun/qqweb/m/qun/confession/js/vconsole.min.js';
  head.appendChild(script);
  sessionStorage.setItem('isTest', 1);
}

// 添加调试
if (
  /debugger/.test(location.href) ||
  window.location.href.indexOf('test.hzqihui.cn') > -1 ||
  sessionStorage.getItem('isTest') == 1 ||
  process.env.NODE_ENV == 'development'
) {
  showLog();
}

// let ct = [];
// document.addEventListener(
//   'click',
//   function() {
//     ct.unshift(+new Date());
//     if (ct.length >= 5) {
//       if (ct[0] - ct[4] < 1000) {
//         showLog();
//       }
//     }
//   },
//   false
// );

// vue错误采集
const BrowserLogger = require('alife-logger');
const __bl = BrowserLogger.singleton({
  pid: 'hizpqrpejx@baa2458ae627484',
  appType: 'web',
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
  sendResource: true,
  enableLinkTrace: true,
  behavior: true,
  useFmp: true,
  enableSPA: true
});
Vue.config.errorHandler = function(err, vm, info) {
  window.__bl && __bl.error(err);
  console.error(err, vm, info);
};

let isDev = process.env.NODE_ENV != 'production';
if (!isDev) {
  Vue.config.devtools = false;
} else {
  Vue.config.devtools = true;
}

var needFresh = false;
window.addEventListener('pageshow', function() {
  if (needFresh) {
    window.location.reload();
  }
});
window.addEventListener('pagehide', function() {
  needFresh = true; // 离开时设置为 需要刷新
});

//fix: 移动端键盘遮挡input的问题
window.addEventListener('resize', function() {
  if (
    document.activeElement.tagName == 'INPUT' ||
    document.activeElement.tagName == 'TEXTAREA'
  ) {
    window.setTimeout(function() {
      document.activeElement.scrollIntoViewIfNeeded();
    }, 0);
  }
});

let timer;
function show(cb) {
  timer = setInterval(() => {
    let page = document.querySelector('.page');
    if (page) {
      let loading = document.querySelector('.pageloading');
      loading && document.body.removeChild(loading);
      page.style.display = 'block';
      clearInterval(timer);
      timer = null;
      cb && cb();
    }
  }, 17);
}
setTimeout(() => {
  let page = document.querySelector('.page');
  let loading = document.querySelector('.pageloading');
  loading && document.body.removeChild(loading);
  page.style.display = 'block';
  timer && clearInterval(timer);
  timer = null;
  console.log('remove');
}, 3000);

let isPc = !navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);

export {
  appBridge,
  Indicator,
  qs,
  Toast,
  api,
  reportError,
  getLang,
  lang,
  show,
  isPc
};
